module.exports = __webpack_public_path__ + "images/category_lp/watch/point-2_42f6ce41f4cff489867b73f36cf8424b.png";